import { render, staticRenderFns } from "./bidOpeningHall.vue?vue&type=template&id=3ea0b2c6&scoped=true"
import script from "./bidOpeningHall.vue?vue&type=script&lang=js"
export * from "./bidOpeningHall.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningHall.vue?vue&type=style&index=0&id=3ea0b2c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0b2c6",
  null
  
)

export default component.exports